interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  variant?: 'light' | 'dark';
}

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  variant = 'light',
}: SectionHeaderProps) {
  const isDark = variant === 'dark';
  const isCenter = align === 'center';

  return (
    <div className={`${isCenter ? 'mx-auto text-center' : 'text-left'} max-w-2xl ${isCenter ? '' : 'mx-0'}`}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] ${
            isDark ? 'text-primary-300' : 'text-primary-600'
          }`}
        >
          <span className="h-px w-6 bg-current" />
          {eyebrow}
        </span>
      )}
      <h2
        className={`mt-4 text-2xl font-bold leading-tight md:text-4xl ${
          isDark ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base leading-relaxed ${isDark ? 'text-background-200' : 'text-foreground-600'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}